module.exports = __webpack_public_path__ + "img/3x.7f37915.jpg";